export default "__VITE_ASSET__CrGxmkSa__"